import React from "react";
import clsx from "clsx";

import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import Grid from "@material-ui/core/Grid";
import { Box } from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import Typography from "@material-ui/core/Typography";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import makeStyles from "@material-ui/core/styles/makeStyles";
import OptimizedTooltip from "../../common/OptimizedTooltip";

const useStyles = makeStyles(theme => ({
  expandingPanelsPublished: {
    "& .MuiInputBase-input, & .MuiFormControlLabel-label": {
      color: theme.variables.rootColor
    }
  },
  expansionRoot: {
    boxShadow: "none",
    margin: `${theme.spacing(0, 0, 3.5)} !important`,

    "&:before": {
      content: "none"
    }
  },
  expansionRootClosed: {
    margin: `${theme.spacing(0, 0, 2.5)} !important`
  },
  expansionSummary: {
    minHeight: "0 !important",
    padding: 0,

    "& .MuiExpansionPanelSummary-content": {
      width: "100%",
      margin: theme.spacing(0.25, 0)
    }
  },
  expansionDetails: {
    padding: 0
  },
  expansionDisabled: {
    cursor: "default"
  },
  gridContent: {
    maxWidth: "calc(100% - 48px)"
  },
  textLight: {
    color: "#808080"
  },
  summaryText: {
    fontSize: "0.9375rem",
    maxWidth: "87%"
  },
  noteText: {
    fontSize: "0.75rem",
    color: "#808080"
  },
  panelError: {
    fontSize: "0.6875rem",
    color: "#D93024"
  },
  borderBottom: {
    borderBottom: theme.variables.border,
    marginBottom: theme.spacing(1.875)
  },
  w48px: {
    width: 48
  }
}));

function Panel({
  expanded,
  panelChange,
  published,
  title,
  summary,
  error,
  children,
  icon,
  id,
  accountDrawer = false,
  ...props
}) {
  const classes = useStyles();

  return (
    <ExpansionPanel
      className={clsx({
        [classes.expansionRoot]: expanded,
        [classes.expansionRootClosed]: !expanded
      })}
      expanded={expanded}
      onChange={panelChange}
    >
      {/* Summary */}
      <ExpansionPanelSummary
        className={classes.expansionSummary}
        tabIndex={-1}
        data-cy={props["data-cy"] || undefined}
      >
        <Grid
          container
          spacing={1}
          className={clsx({
            [classes.expansionDisabled]: accountDrawer
          })}
        >
          <Box component={Grid} className={classes.w48px} item xs="auto">
            {icon}
          </Box>

          <Grid item xs className={classes.gridContent}>
            <Box display="flex" alignItems="center">
              <Typography variant="body1" id={id}>{title}</Typography>

              {/* Error text */}
              <Box ml={2}>
                <Typography className={classes.panelError}>
                  {error ? `${error} more issue${error > 1 ? "s" : ""}` : null}
                </Typography>
              </Box>
            </Box>

            {!expanded && (
              <Box
                className={clsx({
                  [classes.borderBottom]: !summary
                })}
                mt={summary ? 1 : 2.5}
              >
                {summary && (
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    <Typography
                      variant="body1"
                      className={clsx(classes.summaryText, classes.textLight)}
                      noWrap
                    >
                      {summary}
                    </Typography>

                    {!published && (
                      <span
                        data-cy={
                          props["data-cy"]
                            ? props["data-cy"] + "Edit"
                            : undefined
                        }
                      >
                        <OptimizedTooltip placement="bottom" title="Edit">
                          <EditIcon style={{ color: "#B6B6B6" }} />
                        </OptimizedTooltip>
                      </span>
                    )}
                  </Box>
                )}
              </Box>
            )}
          </Grid>
        </Grid>
      </ExpansionPanelSummary>

      {/* Body */}
      <ExpansionPanelDetails className={classes.expansionDetails}>
        {children}
      </ExpansionPanelDetails>
    </ExpansionPanel>
  );
}

export default Panel;
